module.exports = __webpack_public_path__ + "static/media/total.518311e9.png";